// Detects when the browser loaded a stale cached index.html (old bundle) and
// reloads once to pick up the latest deployment. Runs only on app startup,
// before the app renders, so auto-login never runs on old code and a user is
// never interrupted in the middle of a form.
const RELOAD_KEY = "reloadedForVersion";

// Never hold the app longer than this if version.json is slow or unreachable.
const CHECK_TIMEOUT_MS = 3000;

// URL the page was opened with (e.g. /autologin?u=..&p=..), captured before the
// router replaces it with "/". The browser caches each URL separately, so this
// entry must be refreshed too, otherwise reopening the same link stays stale.
const initialUrl = window.location.href;

// Resolves true when a reload to the new build has started (do not render the
// app), false when the app should render as usual.
export const checkForNewVersion = () => {
  if (process.env.NODE_ENV !== "production") return Promise.resolve(false);

  const currentVersion = process.env.REACT_APP_BUILD_VERSION;
  let timedOut = false;
  const check = fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" })
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      // App already rendered after the timeout - never reload under the user.
      if (timedOut) return false;
      if (!data || !data.version || data.version === currentVersion) return false;

      // Reload only once per server version to avoid a reload loop if a
      // proxy keeps serving the old index.html.
      if (sessionStorage.getItem(RELOAD_KEY) === data.version) return false;
      sessionStorage.setItem(RELOAD_KEY, data.version);
      console.info(
        `New build ${data.version} available (running ${currentVersion}), reloading`,
      );

      // Overwrite the cached HTML of the opened URL with the latest from the
      // server, then reload it.
      return fetch(initialUrl, { cache: "reload", credentials: "same-origin" })
        .catch(() => {})
        .then(() => {
          window.location.reload();
          return true;
        });
    })
    .catch(() => false); // version.json missing or not JSON (e.g. SPA fallback)

  const timeout = new Promise((resolve) =>
    setTimeout(() => {
      timedOut = true;
      resolve(false);
    }, CHECK_TIMEOUT_MS),
  );
  return Promise.race([check, timeout]);
};
